// Create a range-array that spans from `from` (inclusive) to `to` (exclusive)
export const range = (from: number, to: number) =>
    new Array(to - from).fill(0).map((_, j) => j + from)

export const rangeInclusive = (from: number, to: number) => {
    const a = range(from, to)
    a.push(to)
    return a
}
